<div class="leads-details-so">
  <h1 class="page-title">Informações do Lead</h1>
  <div class="divider"></div>
  <app-info-field [data]="leadInfo" [columns]="7" />
  <h1 class="page-title" style="margin-top: 3rem">Informações da Simulação</h1>
  <div class="divider"></div>

  <div class="simulation-main-container">
    <div class="simulation-info-column">
      <div class="simulation-info">
        <app-info-field [data]="simulationInfo1" [columns]="4" />
        <div class="spacer" style="height: 4rem"></div>
        <app-info-field [data]="simulationInfo2" [columns]="4" />
        <div class="spacer" style="height: 4rem"></div>
        <app-info-field [data]="simulationInfo3" [columns]="4" />
        <div style="height: 2rem"></div>
        @if (showQuickApproval) {
          <div class="slider-wrapper">
            @if (sliderLoading) {
              <div class="loading-state">
                <div class="loading-spinner"></div>
                Consultando dados da Régua de Aprovação
              </div>
            }

            @if (!sliderLoading && reguaSegments.length > 0) {
              <div class="slider-section">
                <app-slider
                  [value]="sliderValue"
                  [segments]="reguaSegments"
                  (valueChange)="sliderValueChange.emit($event)"
                />
              </div>
            }
          </div>
        }

        <div style="height: 2rem"></div>
      </div>
    </div>

    <div class="car-card-column">
      <app-car-card
        [title]="carCardTitle"
        [anoModelo]="carCardAnoModelo"
        [anoFabricacao]="carCardAnoFabricacao"
        [tipoUso]="carCardTipoUso"
        [carImage]="carCardCarImage"
        [entrada]="carCardEntrada"
        [saldoParcelas]="carCardSaldoParcelas"
        [parcelas]="carCardParcelas"
        (contactClick)="generateSimulation.emit()"
      />
    </div>
  </div>

  <div class="right-buttons">
    <button
      class="nav-btn"
      (click)="navigate.emit(1)"
      appTrackClick
      trackEvent="detalhes_oferta"
      trackCategory="lead_details"
      trackLabel="button_navigation"
    >
      Detalhes da Oferta
    </button>
    <button
      class="nav-btn"
      (click)="navigate.emit(2)"
      appTrackClick
      trackEvent="historico"
      trackCategory="lead_details"
      trackLabel="button_navigation"
    >
      Histórico
    </button>
  </div>
</div>
